export default {
  DATEFORMAT: "yyyy-MM-dd",
  DATEFORMATWITHTIME: "yyyy-MM-dd HH:mm:ss",
  TIMEFORMAT: "HH:mm"
}
